import { FC } from 'react';

import { useOnScroll } from '@app/hooks';
import { backToTopTriggerScrollPosition } from '@app/constants';

import { BackToTopButton } from './BackToTopButton';
import { LibraryChatButton } from './LibraryChatButton';

export const PageBottomControls: FC = () => {
  const scrollDepth = useOnScroll();

  const isBackToTopVisible = scrollDepth > backToTopTriggerScrollPosition;

  return (
    <div>
      <LibraryChatButton isBackToTopVisible={isBackToTopVisible} />
      <BackToTopButton isVisible={isBackToTopVisible} />
    </div>
  );
};
